import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAKb_SYuH78esQzThLvUgA5kba7p_dfoE0",
  authDomain: "deliverytracker-blazeplan.firebaseapp.com",
  databaseURL: "https://deliverytracker-blue-blazeplan.firebaseio.com/",
  projectId: "deliverytracker-blazeplan",
  storageBucket: "deliverytracker-blue-blazeplan",
  messagingSenderId: "633986494855",
  appId: "1:633986494855:web:e9a7343483c4a24d89a322"
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
export const auth = getAuth(app);
export const database = getDatabase(app);
export { storage };


